var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76256 2.01256C4.09075 1.68437 4.53585 1.5 5 1.5C5.46415 1.5 5.90925 1.68437 6.23745 2.01256C6.39365 2.16875 6.5172 2.35138 6.6039 2.54999L6.7039 2.77912C6.81435 3.03221 7.10905 3.14784 7.36215 3.03738L7.8204 2.83739C8.0735 2.72693 8.18915 2.43222 8.0787 2.17914L7.9787 1.95001C7.81775 1.58122 7.58815 1.24195 7.2981 0.951905C6.6886 0.34241 5.86195 0 5 0C4.13805 0 3.31139 0.34241 2.7019 0.951905C2.09241 1.56139 1.75 2.38805 1.75 3.25V4.75H1.5C0.671575 4.75 0 5.42155 0 6.25V9.75C0 10.5785 0.671575 11.25 1.5 11.25H8.5C9.32845 11.25 10 10.5785 10 9.75V6.25C10 5.42155 9.32845 4.75 8.5 4.75H3.25V3.25C3.25 2.78587 3.43437 2.34075 3.76256 2.01256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.33f27dbf6b4e31900b4317aaef97fd4f.svg";
export { ForwardRef as ReactComponent };